import moment from "moment/moment";
import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";

export default function VetDashboardViewLatest({title,data,loading,setCurrent}) {

    let today = moment(new Date().toLocaleString());
    let week = moment(new Date().toLocaleString()).startOf('week');
    const [dataFiltered,setDataFiltered] = useState([]);
    const history = useHistory();

    useEffect(() => {

        let d = [];
        console.log(
            'moment(new Date(created_at).toLocaleString()).format(\'YYYY-MM-DD\')',
            setDataFiltered
        )
        if(title === 'today') {
            d =data.filter(({created_at}) =>
                moment(new Date(created_at).toLocaleString()).format('YYYY-MM-DD') === today.format('YYYY-MM-DD'));
        }else if(title === 'this week') {
            d =data.filter(({created_at}) =>
                moment(new Date(created_at).toLocaleString()).format('YYYY-MM-DD') >= week.format('YYYY-MM-DD'));
        }else{
            d =data.filter(({created_at}) =>
                moment(new Date(created_at).toLocaleString()).format('YYYY-MM-DD') >= today.format('YYYY-MM-01'));
        }

        d = d.filter(({is_redeemed}) => is_redeemed === 0);
        setDataFiltered(d);

    }, [data,title]);

    const boxStyle = {
        background:'rgba(0,0,0,0.05)',
        padding:20
    }

    if(loading === true) return null;
    return (
        <div className="dashboard-box">
            <div className="header">
                New issued vouchers* {title} ({dataFiltered.length})
            </div>
            <div className="dashboard-content">
                {
                    (dataFiltered.length > 0) ?
                        <div>
                            {
                                dataFiltered.map((row,idx) => {
                                    if(row.is_redeemed > 0) return null;
                                    if(idx > 9) return null;
                                    return (
                                        <div key={idx} style={boxStyle}>
                                            <h3>{row.sn}</h3>
                                            <p>{row.first} {row.last}, Email: {row.email}, {(['null',''].indexOf(String(row.phone)) === -1) ? <>Phone: {row.phone}</> : null}</p>
                                            <p>{row.a_type} ({row.a_name}), Sex: {row.a_gender}, Source: {row.a_source}, Age: {row.a_age}</p>
                                        </div>
                                    )
                                })
                            }
                            <div style={{marginTop:20}}>
                                <small>* excludes already redeemed vouchers</small>
                            </div>
                        </div>
                        : <div>No vouchers found for {title}.</div>
                }
            </div>
            <div className={"footer"}>
                <a href={"#"} onClick={(e) => {
                    e.preventDefault();
                    setCurrent('/vouchers');
                    history.push('/vouchers');
                }}>See all</a>
            </div>
        </div>
    )

}
